/**
 * @author        kyle.agronick@zumper.com (Kyle Agronick)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   a function that does nothing
 */

export const noop = () => undefined
